import { render, staticRenderFns } from "./connected-authorization.vue?vue&type=template&id=6c1318b6&scoped=true&"
import script from "./connected-authorization.vue?vue&type=script&lang=js&"
export * from "./connected-authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1318b6",
  null
  
)

export default component.exports